import React, { useRef, forwardRef } from "react";

import styles from "./uwComponent.module.scss";

type TableCheckboxProps = {
	indeterminate: boolean;
	id: string;
	label: string;
};

const TableCheckbox = forwardRef<HTMLInputElement, TableCheckboxProps>(
	({ indeterminate, id, label, ...rest }, ref) => {
		const defaultRef = useRef<HTMLInputElement>(null);
		const resolvedRef = ref ?? defaultRef;

		// will be needed in case of use third state of checkbox
		// useEffect(() => {
		// 	resolvedRef.current.indeterminate = indeterminate;
		// }, [resolvedRef, indeterminate]);

		return (
			<div className={styles.wrappCheckButton}>
				<input type="checkbox" ref={resolvedRef} id={id} {...rest} />
				<label htmlFor={id}>{label}</label>
			</div>
		);
	},
);

export default TableCheckbox;
